import React, { useEffect, useRef, useState } from 'react';

/**
 * YatasBeddingGeoReport: yatasbedding.com.tr GEO sağlık kontrolü (erişim, okunabilirlik,
 * şema, içerik, AI Visibility). Route: /r/yatas-bedding-geo — sidebar menüsünde YOK,
 * yalnız doğrudan link (Efe, 2 Eki 2026).
 *
 * İçerik statik. Yeniden üretmek için: node src/pages/yatas-bedding-geo/build.js
 * Rapor iframe srcDoc içinde çalışır; global seçicileri dashboard'u bozmasın.
 */
export default function YatasBeddingGeoReport() {
  const [html, setHtml] = useState(null);
  const [height, setHeight] = useState(720);
  const boxRef = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./yatasBeddingGeoReportHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // iframe'i içerik alanının kalan yüksekliğine oturt. Rapor kendi içinde kayar,
  // sayfa gövdesi kaymaz — iki kaydırma çubuğu üst üste binmesin.
  useEffect(() => {
    const fit = () => {
      const top = boxRef.current?.getBoundingClientRect().top ?? 0;
      setHeight(Math.max(480, window.innerHeight - top - 16));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [html]);

  return (
    <div ref={boxRef} className="px-2 pb-2">
      {html ? (
        <iframe
          title="Yataş Bedding · GEO Sağlık Kontrolü"
          srcDoc={html}
          style={{
            width: '100%',
            height,
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            display: 'block',
            background: '#F6F8FF',
          }}
        />
      ) : (
        <div
          style={{ height, borderRadius: 12, background: '#F6F8FF' }}
          aria-busy="true"
        />
      )}
    </div>
  );
}
